import _classCallCheck from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import React, { PureComponent } from "react";
//Material imports
import { withStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";

var LoadingFooter = /*#__PURE__*/function (_PureComponent) {
  _inherits(LoadingFooter, _PureComponent);

  var _super = _createSuper(LoadingFooter);

  function LoadingFooter() {
    _classCallCheck(this, LoadingFooter);

    return _super.apply(this, arguments);
  }

  _createClass(LoadingFooter, [{
    key: "render",
    value: function render() {
      var classes = this.props.classes;
      return /*#__PURE__*/React.createElement("div", {
        className: classes.loadingFooterContainer
      }, /*#__PURE__*/React.createElement(CircularProgress, {
        size: 32
      }));
    }
  }]);

  return LoadingFooter;
}(PureComponent);

var styles = {
  loadingFooterContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: 112
  }
};
export default withStyles(styles)(LoadingFooter);